import styled from 'styled-components';

export const PopupBackground = styled.section`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const Popup = styled.div(
  props => `
  background: white;
  border-radius: 1rem;
  position: relative;
  width: 50rem;
  height: ${props?.height ? props?.height : "56%"};
  padding: 2rem;
`);

export const WidgetType = styled.div(
  (props) => `
		padding: 1rem 0;
		border-radius: 0.8rem;
	`);

  export const TripTypeTxt = styled.p(
    props => `
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      font-family: ${props.theme.font.fontFamily};
      font-size: 1.6rem;
      font-weight: normal;
      line-height: 1.33;
      width: 11rem;
    `
  );

  export const OutStandingWarpper = styled.div(
    props => `
      flex-direction: 'row';
      height: 4rem;
      margin: 0.6rem 1rem 0 0;
      padding: 1rem;
      border: 1px solid #2276e3;
      border-radius: 0.8rem;
      background-color: ${props.theme.colors.white.base};
      cursor: pointer;
      display: flex;
    `
  );

  export const StopoversTextCont = styled.div`
	font-family: 'Rubik';
	font-size: 1.6rem;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	color: #2276e3;
  padding: 1.5rem 0 0;
  cursor: pointer;

  span {
    font-family: 'Rubik';
    display: inline-flex;
    background-image: linear-gradient(100deg, #976fc3 0%, #e35471 100%);
    justify-content: center;
    padding: 2px 7px 3px;
    margin-left: 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
  }
`;

export const StopOversCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const CloseCont = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4a4a4a;
  opacity: 0.6;
  margin-top: 26px;
  display: flex;
  justify-content: center;
  align-items: center;

  & .close{
    width: 10px;
    height: 10px;
    margin-top: 8px;
    display: flex;
    cursor: pointer;
  }

  & .close:before{
    content: "";
    background: #fff;
    position: absolute;
    width: 10px;
    border: 1px solid #fff;
    transform: rotate(-45deg);
  }

  & .close:after{
    content: "";
    background: #fff;
    position: absolute;
    width: 10px;
    border: 1px solid #fff;
    transform: rotate(45deg);
  }
`

export const ButtonWrap = styled.div`
  display: flex;
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  button {
    border: 0;
    outline: 0;
    background-color: rgb(255, 109, 56);
    width: 16rem;
    padding: 1rem;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 3rem;
    color: white;
    font-size: 2rem;
    font-family: 'Rubik';
    font-weight: 600;
    box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
  }
`
  
export const OutStandingInputInner = styled.input.attrs(props => (
  {
    ...props, 
    ...{
      autoFocus: props?.autoFocus || false
    }
  }
))(p => `
    width: 100%;
    height: 2.2rem;
    font-family: 'Rubik';
    font-size: 1.6rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    border-width:0px;
    border:none;		
    line-height: 1.38;
    letter-spacing: normal;
    background-color: #fff;
    border:none;
  `);

export const ErrorContainer = styled.div(
  props => `
  font-size: 12px;
  color: #ff3a5c;
  font-weight: 600;
  margin: ${props?.margin ? props?.margin : "1rem 0"};
`)